import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';

@Component({
  selector: 'app-service-container',
  templateUrl: './service-container.component.html',
  styleUrls: ['./service-container.component.css']
})
export class ServiceContainerComponent implements OnInit {
  
  @Output() suggestionMsgEv = new EventEmitter<any>();
  @Input() message: any;
  sessionAttributes:any;

  constructor(public chatbotFunService: ChatbotFunService) { }

  ngOnInit() {
    console.log("message in service-container --->",this.message)
  }


  shouldDisplayMessage(): boolean {
    if (!this.message.resCard) return false;

    const title = this.message.resCard.genericAttachments[0].title;
    const subTitle = this.message.resCard.genericAttachments[0].subTitle;

    return [
      'Here is a quick walkthrough with our services:',
      'So, I can assist you with the following services:',
    ].includes(title) ||
      title.includes('بكل سرور، خلني أزودك بقائمة الخدمات اللي ممكن أساعدك فيها:') ||
      title.includes('Sure, please let me know which of the following you') ||
      title.includes('هذي هي قائمة الخدمات اللي ممكن أساعدك فيها حالياً:') ||
      subTitle === 'tt';
  }

  sendMessage(message, divId, slotToElicit, textTitle) {

    console.log('Message Sent:', { message, slotToElicit, divId });
    const suggestionMsgDetails = {
      message,
      divId,
      slotToElicit,
      sessionAttributes:this.sessionAttributes,
      textTitle
    };
    this.suggestionMsgEv.emit(suggestionMsgDetails);
  }

}
